import SearchableCountrySelect from "../../../components/SearchableCountrySelect";
import { useRegister } from "../RegisterContext";
import { useTranslation } from "react-i18next";


export default function MediaForm() {
  const {
    handleChange,
    handleDetailsChange,
    formData,
    details,
    mediaType,
    setMediaType,
    fieldErrors,
    PHONE_RULES,
    passwordStrength,
    countries
  } = useRegister();

  const { t } = useTranslation();

  return (
    <form
      id="register-step-form"
      className="register-form-grid"
    >
      {/* USERNAME */}
      <div className="input-wrapper">
        <input
          required
          className={`register-inputs ${fieldErrors.username ? "input-error" : ""
            }`}
          name="username"
          value={formData.username || ""}
          placeholder={t("athleteForm.username")}
          onChange={handleChange}
        />

        {fieldErrors.username && (
          <div className="error-message">
            <span className="error-icon">✖</span>
            {fieldErrors.username}
          </div>
        )}
      </div>



      {/* TYPE */}
      <select
        required
        className="register-select"
        name="type"
        value={details.type || ""}
        onChange={(e) => {
          setMediaType(e.target.value);
          handleDetailsChange(e);
        }}
      >
        <option value="">{t("mediaForm.mediaType")}</option>
        <option value="mediaForm.professional">
          {t("mediaForm.professional")}
        </option>
        <option value="mediaForm.company">
          {t("mediaForm.company")}
        </option>
      </select>

      {/* EMAIL */}
      <div className="input-wrapper">
        <input
          required
          className={`register-inputs ${fieldErrors.email ? "input-error" : ""
            }`}
          name="email"
          type="email"
          autoComplete="new-email"
          value={formData.email || ""}
          placeholder={t("athleteForm.email")}
          onChange={handleChange}
        />

        {fieldErrors.email && (
          <div className="error-message">
            <span className="error-icon">✖</span>
            {fieldErrors.email}
          </div>
        )}
      </div>

      {/* PASSWORD */}
      <div className="input-wrapper">
        <input
          className={`register-inputs ${fieldErrors.password
            ? "input-error"
            : passwordStrength.valid
              ? "input-success"
              : ""
            }`}
          type="password"
          name="password"
          autoComplete="new-password"
          placeholder={
            t("athleteForm.password")
          }
          value={formData.password || ""}
          onChange={handleChange}
        />

        {formData.password && (
          <>
            <div className="password-strength-bar">
              <span
                style={{
                  width: `${passwordStrength.score * 20}%`,
                }}
                className={
                  passwordStrength.score <= 2
                    ? "weak"
                    : passwordStrength.score <= 4
                      ? "medium"
                      : "strong"
                }
              />
            </div>

            <small className="password-message">
              {passwordStrength.message}
            </small>
          </>
        )}
      </div>

      {/* PROFESSIONAL */}
      {mediaType === "mediaForm.professional" && (
        <>
          <input
            required
            className="register-inputs"
            name="firstname"
            value={formData.firstname || ""}
            placeholder={
              t("athleteForm.firstname")
            }
            onChange={handleChange}
          />

          <input
            required
            className="register-inputs"
            name="lastname"
            value={formData.lastname || ""}
            placeholder={
              t("athleteForm.lastname")
            }
            onChange={handleChange}
          />

          <div className="input-wrapper">
            <label className="register-date-label" htmlFor="media-birthdate">
              {t("athleteForm.birthdate")}
            </label>
            <input
              id="media-birthdate"
              required
              className="register-inputs"
              type="date"
              name="birthdate"
              value={formData.birthdate || ""}
              onChange={handleChange}
            />

            {fieldErrors.birthdate && (
              <div className="error-message">
                <span className="error-icon">✖</span>
                {fieldErrors.birthdate}
              </div>
            )}
          </div>

          <input
            required
            className="register-inputs"
            name="address"
            value={formData.address || ""}
            placeholder={
              t("athleteForm.address")
            }
            onChange={handleChange}
          />

          <input
            required
            className="register-inputs"
            name="postal_code"
            value={formData.postal_code || ""}
            placeholder={
              t("athleteForm.postalCode")
            }
            onChange={handleChange}
          />

          {/* COUNTRY */}
          <SearchableCountrySelect
            required
            className="register-select"
            name="country"
            value={formData.country || ""}
            onChange={handleChange}
          >
            <option value="">{t("athleteForm.country")}</option>
            {countries.map((country) => (
              <option key={country.code} value={country.name}>
                {country.flag} {country.name}
              </option>
            ))}
          </SearchableCountrySelect>

          <select
            required
            className="register-select"
            name="language"
            value={formData.language}
            onChange={handleChange}
          >

            <option value="">
              {t("athleteForm.language")}
            </option>

            <option value="fr">
              🇫🇷 Français
            </option>

            <option value="en">
              🇬🇧 English
            </option>

            <option value="ar">
              🇲🇦 العربية
            </option>

            <option value="es">
              🇪🇸 Español
            </option>
            <option value="pt">🇵🇹 Português</option>
            <option value="zh">🇨🇳 中文（简体）</option>
            <option value="de">🇩🇪 Deutsch</option>
            <option value="ru">🇷🇺 Русский</option>
            <option value="it">🇮🇹 Italiano</option>
            <option value="sr">🇷🇸 Srpski</option>

          </select>

          <div className="input-wrapper">
            <input
              required
              className={`register-inputs ${fieldErrors.phone ? "input-error" : ""
                }`}
              name="phone"
              value={formData.phone || ""}
              placeholder={
                PHONE_RULES[formData.country]?.placeholder ||
                t("athleteForm.phone")
              }
              onChange={handleChange}
            />

            {fieldErrors.phone && (
              <div className="error-message">
                <span className="error-icon">✖</span>
                {fieldErrors.phone}
              </div>
            )}
          </div>

          <select
            required
            className="register-select"
            name="status"
            value={details.status || ""}
            onChange={handleDetailsChange}
          >
            <option value="">{t("mediaForm.status")}</option>
            <option value="mediaForm.journalist">
              {t("mediaForm.journalist")}
            </option>

            <option value="mediaForm.contentCreator">
              {t("mediaForm.contentCreator")}
            </option>

            <option value="mediaForm.youtuberPodcaster">
              {t("mediaForm.youtuberPodcaster")}
            </option>

            <option value="mediaForm.sportsPhotographer">
              {t("mediaForm.sportsPhotographer")}
            </option>

            <option value="mediaForm.sportsVideographer">
              {t("mediaForm.sportsVideographer")}
            </option>

            <option value="mediaForm.commentator">
              {t("mediaForm.commentator")}
            </option>
          </select>
        </>
      )}

      {/* COMPANY */}
      {mediaType === "mediaForm.company" && (
        <>

          <input
            className='register-inputs'
            name='creation_date'
            value={details.creation_date}
            type="date"
            onChange={handleDetailsChange}
            required
          />

          <input
            required
            className="register-inputs"
            name="company_name"
            value={details.company_name || ""}
            placeholder={t("mediaForm.companyName")}
            onChange={handleDetailsChange}
          />


          <input
            required
            className="register-inputs"
            name="address"
            value={formData.address || ""}
            placeholder={
              t("athleteForm.address")
            }
            onChange={handleChange}
          />

          <input
            required
            className="register-inputs"
            name="postal_code"
            value={formData.postal_code || ""}
            placeholder={
              t("athleteForm.postalCode")
            }
            onChange={handleChange}
          />

          {/* COUNTRY */}
          <SearchableCountrySelect
            required
            className="register-select"
            name="country"
            value={formData.country || ""}
            onChange={handleChange}
          >
            <option value="">{t("athleteForm.country")}</option>
            {countries.map((country) => (
              <option
                key={country.code}
                value={country.name}
              >
                {country.flag} {country.name}
              </option>
            ))}
          </SearchableCountrySelect>

          <select
            required
            className="register-select"
            name="language"
            value={formData.language}
            onChange={handleChange}
          >

            <option value="">
              {t("athleteForm.language")}
            </option>

            <option value="fr">
              🇫🇷 Français
            </option>

            <option value="en">
              🇬🇧 English
            </option>

            <option value="ar">
              🇲🇦 العربية
            </option>

            <option value="es">
              🇪🇸 Español
            </option>
            <option value="pt">🇵🇹 Português</option>
            <option value="zh">🇨🇳 中文（简体）</option>
            <option value="de">🇩🇪 Deutsch</option>
            <option value="ru">🇷🇺 Русский</option>
            <option value="it">🇮🇹 Italiano</option>
            <option value="sr">🇷🇸 Srpski</option>

          </select>

          <input
            required
            className={`register-inputs ${fieldErrors.phone ? "input-error" : ""
              }`}
            name="phone"
            value={formData.phone || ""}
            placeholder={
              PHONE_RULES[formData.country]?.placeholder ||
              t("athleteForm.phone")
            }
            onChange={handleChange}
          />

          {fieldErrors.phone && (
            <div className="error-message">
              <span className="error-icon">✖</span>
              {fieldErrors.phone}
            </div>
          )}
        </>
      )}
    </form>
  );
}
